const isProduction = process.env.NODE_ENV === 'production'

export default {
    isProduction,
    apiURL: 'https://api.camim.com.br/',
    // apiURL: 'http://localhost:4050/',
    basePath: '/',
    timeToExpire: 30,
}
